import { Badge, Button, Image, Tooltip } from 'antd';
import React, { useContext, useEffect, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import CustomContext from '../../context/CustomContext';
import aconexIcon from '../../resources/images/aconex.svg';
import aconexService from '../../services/AconexService';
import notificationService from '../../services/NotificationService';
import styles from './AconexComponent.module.scss';

/**
 * Returns the aconex component.
 * @returns the aconex component.
 */
const AconexComponent = (): React.ReactElement => {
    /*** HOOKS ***/

    const intl = useIntl();
    const context = useContext(CustomContext);
    const { providerAuths } = context;
    const [active, setActive] = useState<boolean>(false);
    const [aconexAllowed, setAconexAllowed] = useState<boolean>();

    /*** EFFECTS ***/

    useEffect(() => {
        const initialize = async () => {
            try {
                const aconexAllowed = !!aconexService.getCachedClientId();
                setAconexAllowed(aconexAllowed);
                if (aconexAllowed && providerAuths.includes('ACONEX')) {
                    setActive(true);
                } else {
                    setActive(false);
                }
            } catch (error) {
                notificationService.displayError(error, intl);
            }
        };
        initialize();
    }, [intl, providerAuths]);

    /*** METHODS ***/

    const connect = async () => {
        try {
            const accessToken = await aconexService.getAccessTokenOrLogin();
            setActive(!!accessToken);
        } catch (error) {
            notificationService.displayError(error, intl);
        }
    };

    /*** COMPONENTS ***/

    if (aconexAllowed && active) {
        return (
            <Tooltip title={<FormattedMessage id="header.settings.aconex.active.tooltip" />} className={styles.icon}>
                <Badge dot offset={[-3, 5]} color="green">
                    <Button type="link" icon={<Image src={aconexIcon} preview={false} className={styles.aconex} />} />
                </Badge>
            </Tooltip>
        );
    } else if (aconexAllowed && active === false) {
        return (
            <Tooltip title={<FormattedMessage id="header.settings.aconex.inactive.tooltip" />} className={styles.icon}>
                <Badge dot offset={[-3, 5]}>
                    <Button
                        type="link"
                        icon={<Image src={aconexIcon} preview={false} className={styles.aconex} />}
                        onClick={connect}
                    />
                </Badge>
            </Tooltip>
        );
    } else {
        return <></>;
    }
};
export default AconexComponent;
